import { lazy } from "react";

export const MonacoEditor = lazy(async () => {
  const [monaco, { default: Editor, loader }, { default: EditorWorker }] =
    await Promise.all([
      import("monaco-editor"),
      import("@monaco-editor/react"),
      import("monaco-editor/editor/editor.worker?worker"),
    ]);

  self.MonacoEnvironment = { getWorker: () => new EditorWorker() };
  loader.config({ monaco });

  return { default: Editor };
});
